import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../../../tornado/icon/icon.component';
import PillShader from '../../../tornado/shaders/pill.shader';
import { getInitialStyle, defaultContext, HORIZONTAL_PADDING, GAP } from './pill.style';

export class Pill extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
          shader: {
            type: PillShader,
          },
          flexItem: false,
        },
        Icon: {
          type: Icon,
        },
        Primary: { text: {} },
        Secondary: { text: {} },
      },
      getInitialStyle(),
    );
  }

  _init() {
    this._style = defaultContext;
    this._maxWidth = 0;

    const icon = this.tag('Icon');
    const primary = this.tag('Primary');
    const secondary = this.tag('Secondary');

    const handleUpdate = () => {
      const paddingX = HORIZONTAL_PADDING[this._style.screenSize];
      const gap = GAP[this._style.screenSize];

      const patch = {
        Background: {},
        Icon: {},
        Primary: {},
        Secondary: {},
      };
      patch.Icon.x = paddingX;
      patch.Primary.x = icon.visible ? Math.round(patch.Icon.x + (icon.finalW ? icon.finalW + gap : 0)) : paddingX;
      patch.Secondary.x = Math.round(patch.Primary.x + (primary.finalW ? primary.finalW + gap : 0));
      patch.w = patch.Secondary.x + secondary.finalW + paddingX;
      this._maxWidth = Math.max(this._maxWidth, patch.w);
      const minWidth = Math.max(this._maxWidth, this._minWidth || 0);

      if (minWidth && patch.w < minWidth) {
        const offset = Math.round((minWidth - patch.w) / 2);

        patch.Icon.x += offset;
        patch.Primary.x += offset;
        patch.Secondary.x += offset;

        patch.w = minWidth;
      }
      patch.Background.w = patch.w;

      this.patch(patch);
    };

    icon.on('txLoaded', handleUpdate);
    secondary.on('txLoaded', handleUpdate);
    primary.on('txLoaded', handleUpdate);
  }

  _detach() {
    this._progress = 0;
    this.tag('Primary').removeAllListeners('txLoaded');
    this.tag('Secondary').removeAllListeners('txLoaded');
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  get minWidth() {
    return this._minWidth;
  }

  set minWidth(value) {
    this._minWidth = value;
  }

  get progress() {
    return this._progress;
  }

  set progress(value) {
    this._progress = value;
    this.tag('Background').shader.progress = Math.max(0, 1 - value);
  }

  set title(value) {
    this.tag('Primary').text.text = value;
  }

  set body(value) {
    this.tag('Secondary').text.text = value;
  }

  set backgroundColor(value) {
    this.patch({
      Background: {
        shader: {
          fillColor: value,
        },
      },
    });
  }

  set textColor(value) {
    this.patch({
      Icon: {
        color: value,
      },
      Primary: {
        color: value,
      },
      Secondary: {
        color: value,
      },
    });
  }

  get displayIcon() {
    return this.tag('Icon').visible;
  }

  set displayIcon(value) {
    this.tag('Icon').visible = value;
  }
}
